import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getSePatientName, getSePatientSurname, GridUtilitiesService, ServerRootService } from '@se/platform';
import { Sex } from '@se/models';
import { ColDef } from 'ag-grid-community';
import { Patient as EstensaPatient, SearchMasterDataOrderType } from 'estensa-module';
import { Observable } from 'rxjs';

export interface PatientSearchOptions {
    firstName: string;
    lastName: string;
    birthDate?: Date;
    sex: Sex | string;
    //sexCode: string,
    taxCode: string;
    searchMasterDataOrderType: SearchMasterDataOrderType;
}

@Injectable({
    providedIn: 'root',
})
export class PatientCertificationGridService extends ServerRootService {
    constructor(
        private httpClient: HttpClient,
        private translate: TranslateService,
        private gridUtils: GridUtilitiesService,
    ) {
        super();
    }

    search(searchOptions: PatientSearchOptions): Observable<EstensaPatient[]> {
        return this.httpClient.post<EstensaPatient[]>(
            this.getServerRoot() + '/Patient/GetPatients',
            searchOptions,
            this.buildOptions(),
        );
    }

    buildColumns(): ColDef[] {
        return [
            {
                colId: '0',
                headerName: this.translate.instant('Patient'),
                headerTooltip: this.translate.instant('Patient'),
                valueGetter: (e) =>
                    `${getSePatientSurname(e.data.patient).toLocaleUpperCase()} ${getSePatientName(e.data.patient).toLocaleUpperCase()}`,
                tooltipValueGetter: (e) =>
                    `${getSePatientSurname(e.data.patient).toLocaleUpperCase()} ${getSePatientName(e.data.patient).toLocaleUpperCase()}`,
                width: 220,
                minWidth: 190,
                suppressSizeToFit: true,
                lockPosition: true,
                pinned: 'left',
                cellStyle: (e) => {
                    //if (e.data.patient.isCertificating === true) // per ora isCertificating non viene passato
                    //    return {'background-color': 'yellow'};
                    //if (e.data.isLocal === true)
                    //    return {'background-color': 'red'};
                    return null;
                },
            },
            {
                colId: '2',
                headerName: this.translate.instant('Sex'),
                headerTooltip: this.translate.instant('Sex'),
                tooltipField: 'sex.code',
                field: 'sex.code',
                width: 100,
                minWidth: 80,
            },
            {
                colId: '3',
                headerName: this.translate.instant('BirthDate'),
                headerTooltip: this.translate.instant('BirthDate'),
                tooltipField: 'birthDate',
                field: 'birthDate',
                width: 150,
                minWidth: 120,
                valueFormatter: this.gridUtils.dateFormatter('birthDate'),
                comparator: this.gridUtils.dateComparator,
            },
            {
                colId: '4',
                headerName: this.translate.instant('BirthPlace'),
                headerTooltip: this.translate.instant('BirthPlace'),
                tooltipField: 'birthPlace.description',
                field: 'birthPlace.description',
                width: 190,
                minWidth: 160,
            },
            {
                colId: '5',
                headerName: this.translate.instant('TaxCode'),
                headerTooltip: this.translate.instant('TaxCode'),
                tooltipField: 'taxCode',
                field: 'taxCode',
                width: 100,
                minWidth: 80,
            },
            {
                colId: '6',
                headerName: this.translate.instant('Residence'),
                headerTooltip: this.translate.instant('Residence'),
                tooltipField: 'residenceCity.description',
                field: 'residenceCity.description',
                width: 190,
                minWidth: 160,
            },
            {
                colId: '7',
                headerName: this.translate.instant('PatientID'),
                headerTooltip: this.translate.instant('PatientID'),
                tooltipField: 'identifier',
                field: 'identifier',
                width: 190,
                minWidth: 160,
            },
            {
                colId: '8',
                headerName: this.translate.instant('Source'),
                headerTooltip: this.translate.instant('Source'),
                tooltipField: 'issuer',
                field: 'issuer',
                width: 190,
                minWidth: 160,
            },
        ];
    }
}
